import { cn, randomId } from '@/utils';
import React, { memo } from 'react';

import { Checkbox as CheckboxAntd, CheckboxProps } from 'antd';

import './style.scss';

export interface ICheckbox extends CheckboxProps {
	label?: string;
	containerClassName?: string;
	require?: boolean;
	horizontal?: boolean;
	labelClassName?: string;
	touched?: boolean;
	errorCode?: string | undefined;
	suffixLabel?: string;
	suffixLabelClassName?: string;
	hasServerError?: boolean;
}
const Checkbox: React.FC<ICheckbox> = ({
	id = randomId()?.toString(),
	label,
	containerClassName = '',
	require = false,
	horizontal = true,
	labelClassName,
	touched,
	errorCode,
	suffixLabel,
	suffixLabelClassName,
	hasServerError = false,
	className,
	...rest
}) => {
	return (
		<div
			className={cn(
				'flex gap-1',
				horizontal ? 'flex-row items-center' : 'flex-col',
				containerClassName
			)}
		>
			{label && (
				<label
					className={cn(
						'text-[13px] font-medium text-font2 cursor-pointer',
						horizontal && 'min-w-[110px]',
						labelClassName
					)}
					htmlFor={id}
				>
					{label} {require && <span className="text-error">*</span>}
				</label>
			)}

			<CheckboxAntd
				id={id}
				{...rest}
				className={cn(className, hasServerError && 'ant-checkbox-error')}
			/>

			{suffixLabel && (
				<label
					className={cn(
						'text-[13px] font-normal text-font2 cursor-pointer',
						suffixLabelClassName
					)}
					htmlFor={id}
				>
					{suffixLabel}
				</label>
			)}
		</div>
	);
};

export default memo(Checkbox);
